import config from '../config';

// Auth config
const Auth = {
  region: process.env.AWS_REGION,
  userPoolId: process.env.AWS_USER_POOL_ID,
  identityPoolId: process.env.AWS_IDENTITY_POOL_ID,
  userPoolWebClientId: process.env.AWS_APP_CLIENT_ID,
  cookieStorage: {
    domain: process.env.AWS_COOKIE_DOMAIN,
    secure: process.env.SERVER !== 'development',
  },
  authenticationFlowType: 'USER_PASSWORD_AUTH',
};
if (process.env.AWS_OAUTH_DOMAIN) {
  Auth.oauth = {
    domain: process.env.AWS_OAUTH_DOMAIN,
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: config.get('startURL'),
    redirectSignOut: config.get('startURL'),
    // 'code' for Authorization code grant
    // 'token' for Implicit grant
    responseType: 'code',
    // optional, for Cognito hosted ui specified options
    options: {
      // Indicates if the data collection is enabled to support
      // Cognito advanced security features. By default, this flag is set to true.
      AdvancedSecurityDataCollectionFlag: false,
    },
  };
}

// API config
const endpoints = [];
if (process.env.LAWYER_API_ENDPOINT) {
  endpoints.push({
    name: 'lawyerAPI',
    endpoint: process.env.LAWYER_API_ENDPOINT,
    region: process.env.AWS_REGION,
    custom_header: async () => ({
      'Content-Type': 'application/json',
      // 'X-Api-Token': process.env.LAWYER_API_TOKEN,
    }),
  });
}

const amplifyConfig = {
  Auth,
};

if (endpoints.length > 0) {
  amplifyConfig.API = {
    endpoints,
  };
}

export default amplifyConfig;



// WEBPACK FOOTER //
// ./src/amplifyConfig.js